var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"schedule-recent-list"},_vm._l((_vm.items),function(item){return _c('li',{key:item.id,staticClass:"schedule-recent-list__item"},[_c('EnvironmentScheduleCard',{attrs:{"environment":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }